// extracted by mini-css-extract-plugin
module.exports = {"headingStyle":"QuickTour_headingStyle__LHNiF","FooterQ":"QuickTour_FooterQ__2ljLi"};